// Generated by CoffeeScript 2.4.1
(function() {
  var Weaver, WeaverRelationIn;

  Weaver = require('./Weaver');

  WeaverRelationIn = class WeaverRelationIn {
    constructor(key) {
      this.key = key;
      this.nodes = []; // All nodes that this relation points to
    }

    all() {
      return this.nodes;
    }

    first() {
      return this.all()[0];
    }

    addSource(node) {
      return this.nodes.push(node);
    }

  };

  // Export
  module.exports = WeaverRelationIn;

}).call(this);
